import { PhysicalAddressOfPartnerInterface } from "@/api/Users/GetCurrentUser/Interfaces/PhysicalAddressOfPartnerInterface";
import { getRandomInteger } from "@/helpers/getRandomInteger";
import { RootState } from "@/store/Store";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { PhoneInterface } from "@/api/Users/GetCurrentUser/Interfaces/PhoneInterface";
import { PhoneFormState } from "../../RegisterNewPartnerForm/Slice/PhysicalAddressSlice";
import { notSelectedId } from "@/config/Other";
import { PhoneUnitInterface } from "@/components/PhonesManager/Interfaces/PhoneUnitInterface";

export interface ManagePhoneFormInterface {
    state: PhoneFormState,
    address: PhysicalAddressOfPartnerInterface,
    phoneId: number,
    phone: string,
    title: string,
    open: boolean,
}

export interface EditPhysicalAddressFormInterface {
    id: number,
    addressField: string,
    country_id: number,
    city_id: number,
}

function getInitialState() {
    return {
        addresses: [] as PhysicalAddressOfPartnerInterface[],
        formStage: "new",
        form: {
            id: notSelectedId,
            addressField: "",
            country_id: notSelectedId,
            city_id: notSelectedId,
        } as EditPhysicalAddressFormInterface,
        managePhoneForm: {
            state: "new",
            address: {
                id: notSelectedId,
                address: "",
            },
            phoneId: notSelectedId,
            phone: "",
            title: "",
            open: false,
        } as ManagePhoneFormInterface,
    };
}

type InitialState = ReturnType<typeof getInitialState>;

export const EditPartnerPhysicalAddressSlice = createSlice({
    name: "EditPartnerPhysicalAddressSlice",
    initialState: getInitialState(),
    reducers: {
        clearAddressForm: (state, action: PayloadAction<void>) => {
            const initialState = getInitialState();
            state.form.id = initialState.form.id;
            state.form.addressField = initialState.form.addressField;
            state.form.country_id = initialState.form.country_id;
            state.form.city_id = initialState.form.city_id;
        },
        setAddressField: (state, action) => {
            state.form.addressField = action.payload;
        },
        setAddressFormValue: <K extends keyof EditPhysicalAddressFormInterface>(state: InitialState, action: PayloadAction<{name: K, value: EditPhysicalAddressFormInterface[K]}>) => {
            state.form[action.payload.name] = action.payload.value;
        },
        setAddresses: (state, action) => {
            state.addresses = action.payload;
        },
        setAddressForm: (state, action) => {
            state.form.id = action.payload.id;
            state.form.addressField = action.payload.addressField;
        },
        setFormStage: (state, action) => {
            state.formStage = action.payload;
        },
        /** @deprecated */
        addPhoneToAnAddress: (state, action: PayloadAction<{ addressId: PhysicalAddressOfPartnerInterface["id"], phone: PhoneUnitInterface }>) => {
            // const address = state.addresses.find(unit => unit.id === action.payload.addressId);
            // if (address !== undefined) {
            //     address.phones.push(action.payload.phone);
            // }
        },
        setPhonesForAddress: (state, action: PayloadAction<{ addressId: PhysicalAddressOfPartnerInterface["id"], phones: PhoneUnitInterface[] }>) => {
            const address = state.addresses.find(unit => unit.id === action.payload.addressId);
            if (address !== undefined) {
                address.phones = action.payload.phones;
            }
        },
        changePhoneForm: (state, action: PayloadAction<ManagePhoneFormInterface>) => {
            state.managePhoneForm = action.payload;
        },
        clearPhoneForm: (state, action: PayloadAction<void>) => {
            state.managePhoneForm.phone = "";
            state.managePhoneForm.title = "";
            state.managePhoneForm.phoneId = notSelectedId;
            state.managePhoneForm.state = "new";
        },
        deletePhoneFromAddress: (state, action: PayloadAction<{ addressId: PhysicalAddressOfPartnerInterface["id"], phone: PhoneInterface["phone"] }>) => {
            const address = state.addresses.find(unit => unit.id === action.payload.addressId);
            if (address !== undefined) {
                address.phones = address.phones.filter(unit => unit.phone !== action.payload.phone);
            }
        },
        /** @deprecated */
        changePhoneForAddress: (state, action: PayloadAction<{ addressId: PhysicalAddressOfPartnerInterface["id"], phone: PhoneInterface }>) => {
            // const address = state.addresses.find(unit => unit.id === action.payload.addressId);
            // if (address === undefined) {
            //     return;
            // }
            // address.phones = address.phones.map(unit => {
            //     if (unit.id === action.payload.phone.id) {
            //         return action.payload.phone;
            //     }

            //     return unit;
            // });
        },
        clearAddressForPhoneForm: (state, action: PayloadAction<void>) => {
            const initialState = getInitialState();
            state.managePhoneForm.address = initialState.managePhoneForm.address;
        }
    }
});

export const {
    setAddressField,
    setAddressForm,
    setFormStage,
    setAddresses,
    addPhoneToAnAddress,
    changePhoneForm,
    clearPhoneForm,
    deletePhoneFromAddress,
    changePhoneForAddress,
    clearAddressForPhoneForm,
    setPhonesForAddress,
    setAddressFormValue,
    clearAddressForm,
} = EditPartnerPhysicalAddressSlice.actions;

export const formSelector = (state: RootState) => state.inCPEditPartnerFormPhysicalAddress.form;
export const addressesSelector = (state: RootState) => state.inCPEditPartnerFormPhysicalAddress.addresses;
export const addressFieldSelector = (state: RootState) => state.inCPEditPartnerFormPhysicalAddress.form.addressField;
export const formStageSelector = (state: RootState) => state.inCPEditPartnerFormPhysicalAddress.formStage;
export const physicalAddressesAreCorrectSelector = (state: RootState) => {
    if ( ! Array.isArray(state.inCPEditPartnerFormPhysicalAddress.addresses)) {
        return false;
    }
    return state.inCPEditPartnerFormPhysicalAddress.addresses.length > 0;
};
export const phoneFormSelector = (state: RootState) => state.inCPEditPartnerFormPhysicalAddress.managePhoneForm;

export const EditPartnerPhysicalAddressReducer = EditPartnerPhysicalAddressSlice.reducer;

export const FormStage = {
    new: "new",
    edit: "edit",
}
